<script setup>
  defineEmits(['input:change']);

  const model = defineModel();

  const props = defineProps({
    attributes: {
      type: Object,
      required: true
    },  
  });
</script>

<template>
  <input
    @change="$emit('input:change', $event)"
    :type="props.attributes.inputType"
    :id="props.attributes.id" 
    :disabled="props.attributes.disabled"
    :true-value="props.attributes.trueValue"
    :false-value="props.attributes.falseValue"
    v-model="model"
    class="jwx-hidden-control" 
  />
</template>